<template>
  <div>
    <v-row
      class="mb-6"
      no-gutters
      align="center"
    >
      <v-btn
        :icon="$store.state.isMobile"
        :text="!$store.state.isMobile"
        color="indigo accent-3"
        v-on:click="goBack"
      >
        <v-icon
          :left="!$store.state.isMobile"
          size="20"
        >mdi-keyboard-backspace</v-icon>
        <span
          v-show="!$store.state.isMobile"
          style="font-size: 18px;"
        >Back</span>
      </v-btn>

      <h1
        v-if="id == 0 || typeof id == 'undefined'"
        class="color-services page-heading"
      >
        Add New Service
      </h1>
      <h1
        v-else
        class="color-services page-heading"
      >Edit Service</h1>
      <v-spacer />
      <v-btn
        v-if="(id == 0 || typeof id == 'undefined') && !$store.state.isMobile"
        text
        color="indigo accent-3"
        @click="validateAndSubmit"
        :loading="formSubmitLoading"
      >
        <span class="title">Submit</span>
      </v-btn>
      <v-btn
        v-else-if="!$store.state.isMobile"
        text
        color="indigo accent-3"
        @click="validateAndEdit"
        :loading="formSubmitLoading"
      >
        <span class="title">Save Changes</span>
      </v-btn>
    </v-row>

    <v-row
      justify="center"
      align="center"
      v-if="formLoading"
      style="height:50vh"
    >
      <v-progress-circular
        :size="70"
        color="#5c648b"
        indeterminate
      ></v-progress-circular>
    </v-row>

    <v-card v-if="!formLoading">
      <v-card-text>
        <v-form
          ref="masterForm"
          lazy-validation
        >
          <v-row no-gutters>
            <v-col
              cols="12" sm="6"
              class="pa-4"
            >
              <v-row no-gutters>
                <v-col
                  md="4"
                  xs="2"
                >
                  <span class="lable-text">Service</span>
                </v-col>
                <v-col xs="8">
                  <v-text-field
                    v-model="name"
                    placeholder="Enter Service Name"
                    :rules="[rules.required]"
                    class="custom-bottom-line"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="mt-6 pa-4">
      <v-card-title
        class="color-services"
        v-if="!serviceStepsLoading"
      >
        Service Steps
        <v-spacer></v-spacer>
      </v-card-title>

      <v-row
        justify="center"
        align="center"
        v-if="serviceStepsLoading"
        style="height:50vh"
        class="ma-0"
      >
        <v-progress-circular
          :size="70"
          color="#5c648b"
          indeterminate
        ></v-progress-circular>
      </v-row>

      <v-simple-table
        class="px-4 pb-4"
        v-else
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="black--text font-weight-bold body-2 text-left">
                Steps
              </th>

              <th class="black--text font-weight-bold body-2 text-left">
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(element, index) in serviceSteps"
              :key="element.id"
            >
              <td>
                <v-tooltip
                  bottom
                  content-class="tooltip-custom"
                >
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                      style="cursor: pointer;"
                    >{{
                      element.step_detail_title
                    }}</span>
                  </template>
                  <span>{{ element.step_detail_title }}</span>
                </v-tooltip>
              </td>

              <td>
                <v-btn
                  text
                  color="indigo accent-3"
                  @click="removeStep(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <v-btn
        text
        @click="searchStepDialog = true"
        color="indigo accent-3"
      >
        <v-icon>mdi-plus</v-icon>
        <span>Add Step</span>
      </v-btn>

      <v-dialog
        v-model="searchStepDialog"
        scrollable
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <v-row
              no-gutters
              align="center"
            >
              <span class="modal-heading">Search Step</span>
              <v-spacer />
              <v-btn
                color="blue darken-1"
                :text="!$store.state.isMobile"
                :icon="$store.state.isMobile"
                @click="searchStepDialog = false"
              >
                <v-icon
                  size="16"
                  :left="!$store.state.isMobile"
                >mdi-close</v-icon>
                <span v-show="!$store.state.isMobile">Close</span>
              </v-btn>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-divider class="mt-2 mb-1"></v-divider>
            <v-card-title class="pa-0 mt-2">
              <v-row
                no-gutters
                justify="end"
                align="center"
              >
                <v-text-field
                  outlined
                  v-model="stepSearch"
                  hide-details
                  placeholder="Search"
                  prepend-inner-icon="mdi-magnify"
                  color="indigo accent-3"
                  class="pe-3 search-field"
                ></v-text-field>
                <v-btn
                  dark
                  @click="addStepDialog = true"
                  color="indigo accent-3"
                >
                  <v-icon>mdi-plus</v-icon>
                  <span>Add New Step</span>
                </v-btn>
              </v-row>
            </v-card-title>
            <v-data-table
              :headers="stepHeaders"
              :items="stepItems"
              :options.sync="stepPagination"
              :server-items-length="stepItemsTotal"
              :loading="stepLoading"
              :page.sync="stepPagination.page"
              hide-default-footer
              mobile-breakpoint="0"
              @page-count="10"
            >
              <template v-slot:[`item.id`]="{ item }">
                <v-btn
                  text
                  color="indigo accent-3"
                  style="text-transform: none;"
                  small
                  @click="addStep(item)"
                >
                  <span>Add Step</span>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <EmptyState text="Step" />
              </template>
            </v-data-table>
            <v-divider class="mt-1 mb-2"></v-divider>
            <v-row
              align="center"
              justify-md="end"
            >
              <span
                class="body-2 text-color"
                style="margin-end: 73px"
              >
                Showing
                {{
                  stepPagination.itemsPerPage * stepPagination.page -
                    stepPagination.itemsPerPage +
                    1
                }}
                -
                {{
                  stepPagination.itemsPerPage * stepPagination.page >
                  stepItemsTotal
                    ? stepItemsTotal
                    : stepPagination.itemsPerPage * stepPagination.page
                }}
                of {{ stepItemsTotal }}
              </span>

              <v-btn
                text
                color="indigo accent-3 body-2"
                :disabled="1 == stepPagination.page"
                @click="stepPagination.page = stepPagination.page - 1"
              >
                <span>Previous</span>
              </v-btn>

              <span class="body-2 text-color ms-9 me-9">Page {{ stepPagination.page }}</span>

              <v-btn
                text
                color="indigo accent-3"
                :disabled="
                  Math.ceil(stepItemsTotal / 10) == stepPagination.page ||
                    stepItemsTotal < 1
                "
                @click="stepPagination.page = stepPagination.page + 1"
              >
                <span>Next</span>
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="addStepDialog"
        scrollable
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <v-row
              no-gutters
              align="center"
            >
              <span class="modal-heading">Add New Step</span>
              <v-spacer />
              <v-btn
                color="blue darken-1"
                :text="!$store.state.isMobile"
                :icon="$store.state.isMobile"
                @click="addStepDialog = false"
              >
                <v-icon
                  size="16"
                  :left="!$store.state.isMobile"
                >mdi-close</v-icon>
                <span v-show="!$store.state.isMobile">Close</span>
              </v-btn>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-form
              ref="stepForm"
              lazy-validation
            >
              <v-row no-gutters>
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col
                      md="4"
                      xs="2"
                    >
                      <span class="lable-text">Step</span>
                    </v-col>
                    <v-col xs="8">
                      <v-text-field
                        v-model="stepName"
                        placeholder="Enter Step Name"
                        :rules="[rules.required]"
                        class="custom-bottom-line"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
            <v-row class="ma-0">
              <v-spacer />
              <v-btn
                dark
                @click="addNewStep"
                color="indigo accent-3"
              >
                <span>Submit</span>
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>

    <v-row class="mt-2">
      <v-spacer />
      <v-btn
        v-if="
          (id == 0 || typeof id == 'undefined') &&
            $store.state.isMobile &&
            serviceSteps.length > 0
        "
        text
        color="indigo accent-3"
        @click="validateAndSubmit"
        :loading="formSubmitLoading"
      >
        <span class="title">Submit</span>
      </v-btn>
      <v-btn
        v-else-if="$store.state.isMobile && serviceSteps.length > 0"
        text
        color="indigo accent-3"
        @click="validateAndEdit"
        :loading="formSubmitLoading"
      >
        <span class="title">Save Changes</span>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Axios from "../../../../api/BaseAxios";
import { ROUTER_URL, API_CLIENT_URL } from "../../../../constants/urls";
import Keys from "../../../../constants/keys";

import store from "../../../../store";
import RULES from "../../../../common/fieldRules";

import MasterPermissionKeys from "../../../../constants/PermissionKeys";
import Helper from "../../../../helper";
import ClientApiHelper from "../../../../api/common/ClientApis";
import EmptyState from "../../../../components/EmptyState/EmptyState";

export default {
  name: "ClientAddEditService",
  components: {
    EmptyState,
  },
  data () {
    return {
      router: ROUTER_URL,
      rules: RULES,
      formLoading: false,
      formSubmitLoading: false,
      id: 0,
      PermissionKeys: [],
      name: null,
      stepName: "",
      addStepDialog: false,
      searchStepDialog: false,
      serviceStepsLoading: false,
      serviceSteps: [],
      stepHeaders: [
        {
          text: "Title",
          value: "step_details.step_detail_title",
          class: "black--text font-weight-bold",
          sortable: false,
        },

        {
          text: "Action",
          value: "id",
          class: "black--text font-weight-bold",
          sortable: false,
          align: "right",
        },
      ],
      stepPagination: {},
      stepItems: [],
      stepItemsTotal: 0,
      stepLoading: false,
      stepSearch: "",
    };
  },
  created () {
    this.id = this.$route.params.id;
    this.PermissionKeys = MasterPermissionKeys;
  },
  computed: {
    ...mapGetters({
      permissions: "mainStore/getPermissions",
    }),
  },
  watch: {
    permissions () {
      if (
        this.$route.name ===
        this.router.adminPanel.children.clientMaster.children.classAdd.name &&
        this.permissions.indexOf(
          this.PermissionKeys.CLIENT_MASTERS_SERVICE_ADD
        ) < 0
      ) {
        this.$router.push({ name: "eblityLogin" });
      } else if (
        this.$route.name ===
        this.router.adminPanel.children.clientMaster.children.classEdit
          .name &&
        this.permissions.indexOf(
          this.PermissionKeys.CLIENT_MASTERS_SERVICE_EDIT
        ) < 0
      ) {
        this.$router.push({ name: "eblityLogin" });
      }
    },
    addStepDialog () {
      this.$refs.stepForm.reset();
    },
    searchStepDialog () {
      this.stepSearch = "";
    },
    stepSearch () {
      this.searchSteps();
    },
    stepPagination () {
      this.searchSteps();
    },
  },
  methods: {
    checkIfSteps () {
      if (this.serviceSteps.length < 1) {
        store.dispatch("snackBar/showToast", {
          message: "Atleast One Step Required",
          color: "E",
        });
      }
      return this.serviceSteps.length > 0;
    },
    getFormData () {
      var self = this;
      self.formLoading = true;
      const successHandler = () => {
        self.formLoading = false;
      };
      const failureHandler = {};
      let requestParams = {};
      Axios.request_POST(
        API_CLIENT_URL.clientGradeList,
        requestParams,
        {},
        successHandler,
        failureHandler,
        false
      );
    },
    validateAndSubmit () {
      var self = this;

      if (this.$refs.masterForm.validate() && this.checkIfSteps()) {
        const successHandler = (res) => {
          console.log(res);
          store.dispatch("snackBar/showToast", {
            message: "New Service Added",
            color: "S",
          });
          self.goBack();
          self.$refs.masterForm.reset();
          self.formSubmitLoading = false;
          // self.$router.push({
          //       name:
          //         this.router.clientPanel.children.masters.children.masterList
          //           .name,
          //     });
        };

        const failureHandler = (res) => {
          console.log(res);
          self.formSubmitLoading = false;
        };

        let requestParams = {};
        requestParams[Keys.NAME] = this.name;

        let stepList = Array();

        this.serviceSteps.forEach((element, index) => {
          stepList.push({
            id: element.id,
            order: index
          })
        });

        requestParams[Keys.STEPS_LIST] = stepList;

        self.formSubmitLoading = true;

        Axios.request_POST(
          API_CLIENT_URL.clientServiceAdd,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      }
    },
    goBack () {
      Helper.goBack();
      // router.go(-1);
    },
    getServiceData () {
      const self = this;
      this.loading = true;
      const successHandler = (res) => {
        self.loading = false;
        self.name = res.data.data.service_name;
      };
      const failureHandler = (res) => {
        console.log(res);
        self.goBack();
      };
      let requestParams = {};
      requestParams[Keys.ID] = this.id;
      Axios.request_GET(
        API_CLIENT_URL.clientServiceDetails,
        requestParams,
        {},
        successHandler,
        failureHandler,
        false
      );
    },
    getServiceStepList () {
      var self = this;

      this.serviceStepsLoading = true;

      const successHandler = (res) => {
        for (let i = 0; i < res.data.data.length; i++) {
          res.data.data[i].due_date = this.startDate;
          res.data.data[i].menu = false;
        }
        // self.serviceSteps = res.data.data;
        res.data.data.forEach((element) => {
          self.serviceSteps.push(element.step_details);
        });
        self.serviceStepsLoading = false;
      };

      const failureHandler = (res) => {
        console.log(res);
      };

      let requestParams = {};

      requestParams[Keys.CLIENT_SERVICE_ID] = this.id;

      console.log(requestParams);

      Axios.request_POST(
        API_CLIENT_URL.clientServiceStepList,
        requestParams,
        {},
        successHandler,
        failureHandler,
        false
      );
    },
    validateAndEdit () {
      var self = this;

      if (this.$refs.masterForm.validate() && this.checkIfSteps()) {
        const successHandler = (res) => {
          console.log(res.data.data);

          store.dispatch("snackBar/showToast", {
            message: "Service Edited",
            color: "S",
          });
          self.formSubmitLoading = false;
          self.goBack();
        };

        const failureHandler = (res) => {
          console.log(res);
          self.formSubmitLoading = false;
        };

        let requestParams = {};

        requestParams[Keys.ID] = this.id;
        requestParams[Keys.NAME] = this.name;
        let stepList = Array();

        this.serviceSteps.forEach((element, index) => {
          stepList.push({
            id: element.id,
            order: index + 1
          })
        });

        requestParams[Keys.STEPS_LIST] = stepList;
        self.formSubmitLoading = true;

        Axios.request_PATCH(
          API_CLIENT_URL.clientServiceEdit,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      }
    },
    addNewStep () {
      var self = this;
      this.addStepLoading = true;

      if (this.$refs.stepForm.validate()) {
        const successHandler = (res) => {
          console.log(res);
          store.dispatch("snackBar/showToast", {
            message: "New Step Added",
            color: "S",
          });
          self.$refs.stepForm.reset();
          self.serviceSteps.push(res.data.data);
          self.addStepLoading = false;
          self.addStepDialog = false;
          self.searchStepDialog = false;
        };

        const failureHandler = (res) => {
          console.log(res);
          self.addStepLoading = false;
          self.addStepDialog = false;
          self.searchStepDialog = false;
        };

        let requestParams = {};
        requestParams[Keys.TITLE] = this.stepName;

        console.log(requestParams);

        ClientApiHelper.addClientMasterStep(
          requestParams,
          successHandler,
          failureHandler
        );
      }
    },
    searchSteps () {
      var self = this;

      this.stepLoading = true;

      const successHandler = (res) => {
        self.isLoadingSteps = false;
        self.searchStepsList = res.data.data;

        self.stepLoading = false;
        self.stepItems = res.data.data;
        self.stepItemsTotal = res.data.recordsTotal;
      };

      const failureHandler = (res) => {
        console.log(res);
      };

      let requestParams = {};

      if (this.id) {
        requestParams[Keys.CLIENT_SERVICE_ID] = this.id;
        requestParams[Keys.IS_SERVICE_EXCLUDE] = true;
      }

      requestParams[Keys.LENGTH] = this.stepPagination.itemsPerPage;
      requestParams[Keys.PAGE] = this.stepPagination.page;
      requestParams[Keys.SEARCH] = this.stepSearch;

      ClientApiHelper.getServiceSteps(
        requestParams,
        successHandler,
        failureHandler
      );
    },
    addStep (step) {
      this.serviceSteps.push(step.step_details);
      this.searchStepDialog = false;
    },
    removeStep (index) {
      this.serviceSteps.splice(index, 1);
    },
  },
  mounted () {
    if (
      this.$route.params.id != 0 &&
      typeof this.$route.params.id != "undefined"
    ) {
      this.getServiceData();
      this.getServiceStepList();
    }
  },
};
</script>

<style></style>
